import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  /** `md` for records and list items, `lg` for conversational surfaces (spec §4). */
  radius?: 'sm' | 'md' | 'lg';
  raised?: boolean;
  className?: string;
  as?: 'div' | 'article' | 'li' | 'section';
}

export function Card({
  children,
  radius = 'md',
  raised = true,
  className = '',
  as: Tag = 'div',
}: CardProps) {
  return (
    <Tag
      className={className}
      style={{
        background: 'var(--color-surface-raised)',
        borderRadius: `var(--radius-${radius})`,
        boxShadow: raised ? 'var(--elevation-raised)' : undefined,
      }}
    >
      {children}
    </Tag>
  );
}

interface ChipProps {
  children: ReactNode;
  className?: string;
}

/** Plain outlined pill. Used for overflow counts and neutral metadata. */
export function Chip({ children, className = '' }: ChipProps) {
  return (
    <span
      className={`inline-flex items-center gap-2 t-caption ${className}`}
      style={{
        minHeight: '34px',
        padding: '0 var(--space-3)',
        borderRadius: 'var(--radius-full)',
        border: '1.5px solid var(--color-border-strong)',
        color: 'var(--color-text-primary)',
      }}
    >
      {children}
    </span>
  );
}
